import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePopup = defineStore('popup', () => {

  const popups = ref({
    privacy_policy : false,
    terms_conditions : false
  })
  
  function open(name){
    popups.value[name] = true;
  }

  function close(name){
    popups.value[name] = fale;
  }

  function toggle(name){
    popups.value[name] = !popups.value[name];
  }

  return { 
    popups,
    open,
    close,
    toggle
  }

})